module.exports = __webpack_public_path__ + "static/media/jp.4187b1d4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/jp.svg
// module id = 1074
// module chunks = 0